var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-chip"},[_c('span',{staticClass:"block-chip__name"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"block-chip__button",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }